export default __webpack_public_path__ + "assets/images/aistudio/9b2569dfe281e33ddc720ba0a548fe6c.png";